import { isOasysSsoEnabled } from '@/auth/auth.config'
import SsoLogout from '@/views/auth/SsoLogout'
import SsoCallback from '@/views/auth/SsoCallback'
import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import ConsentGate from './ConsentGate'
import AuthorityGuard from './AuthorityGuard'
import AppRoute from './AppRoute'
import PageContainer from '@/components/template/PageContainer'
import { protectedRoutes, publicRoutes } from '@/configs/routes.config'
import { visitorRoutes } from '@/configs/routes.config/authRoute'
import appConfig from '@/configs/app.config'
import { useAuth } from '@/auth'
import { Routes, Route, Navigate } from 'react-router-dom'
import type { LayoutType } from '@/@types/theme'
import EmployeeManagement from '@/views/hrms/EmployeeManagement'

interface ViewsProps {
    pageContainerType?: 'default' | 'gutterless' | 'contained'
    layout?: LayoutType
}

type AllRoutesProps = ViewsProps


 //const logincount = localStorage.getItem('logincount');
   const logincount = localStorage.getItem('logincount')
let Urlparth = appConfig.authenticatedEntryPath

  const login = sessionStorage.getItem('login')

  if(login === '1')
{

if (logincount === null || logincount === 'null') {
    localStorage.clear()
    Urlparth = appConfig.unAuthenticatedEntryPath // Or your default public path
}
}




const AllRoutes = (props: AllRoutesProps) => {
    const { user } = useAuth()

    return (
        <Routes>
            {/* Callback must bypass both authentication route guards. */}
            <Route path="/auth/callback" element={isOasysSsoEnabled() ? <SsoCallback /> : <Navigate replace to="/sign-in-v2" />} />
            <Route path="/auth/logout" element={isOasysSsoEnabled() ? <SsoLogout /> : <Navigate replace to="/sign-in-v2" />} />
            {/* Visitor self-registration (QR code). Outside both guards so the
                gate display and the visitor's phone reach these pages whether
                or not a session happens to be stored in the browser. */}
            {visitorRoutes.map((route) => (
                <Route
                    key={route.key}
                    path={route.path}
                    element={
                        <AppRoute
                            routeKey={route.key}
                            component={route.component}
                        />
                    }
                />
            ))}
            <Route path="/" element={<ProtectedRoute />}>
                <Route element={<ConsentGate />}>
                    <Route
                        path="/"
                        element={<Navigate replace to={Urlparth} />}
                    />
                    {protectedRoutes.map((route, index) => (
                        <Route
                            key={route.key + index}
                            path={route.path}
                            element={
                                <AuthorityGuard
                                    userAuthority={user.authority}
                                    authority={route.authority}
                                >
                                    <PageContainer {...props} {...route.meta}>
                                        <AppRoute
                                            routeKey={route.key}
                                            component={route.component}
                                            {...route.meta}
                                        />
                                    </PageContainer>
                                </AuthorityGuard>
                            }
                        />
                    ))}
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Route>
            </Route>
            <Route path="/" element={<PublicRoute />}>
                {publicRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={
                            <AppRoute
                                routeKey={route.key}
                                component={route.component}
                                {...route.meta}
                            />
                        }
                    />
                ))}
            </Route>
        </Routes>
    )
}

export default AllRoutes
